import React from 'react';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
import "./index.css";
import ReactDOM from 'react-dom/client';

import { MyContextProvider } from "./MyContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "./components/Landing_Page/LandingPage/LandingPageCss/variables.css";
import "./components/Landing_Page/LandingPage/LandingPageCss/utilities.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MyContextProvider>
  <App />
</MyContextProvider>
);